import * as React from "react";
import Marker from "./marker";
import StoreStar from "./store-star";
export default class StoreCard extends React.Component {
    constructor(props) {
        super(props);
        this.toggleServices = () => {
            if (this.props.toggleList) {
                this.props.toggleList(this.props.store);
            }
        };
        this.toggleAmenities = () => {
            this.setState({
                toggle: !this.state.toggle
            });
        };
        this.createList = (store) => {
            let amenitiesList = [];
            if (store.SpecialEventsOrdering) {
                amenitiesList.push("Special Events Ordering");
            }
            if (store.OnSiteSpecialEvents) {
                amenitiesList.push("On Site Special Events");
            }
            if (store.KegSales) {
                amenitiesList.push("Keg Sales");
            }
            if (store.OnSiteKitchen) {
                amenitiesList.push("On Site Kitchen");
            }
            if (store.DeliveryService) {
                amenitiesList.push("Delivery Service");
            }
            if (store.SpecialOrdering) {
                amenitiesList.push("Special Ordering");
            }
            if (store.OnlineOrdering) {
                amenitiesList.push("Online Ordering");
            }
            if (store.SommelierOnStaff) {
                amenitiesList.push("Sommelier On Staff");
            }
            if (store.LicenseeSales) {
                amenitiesList.push("Licensee Sales");
            }
            return amenitiesList;
        };
        this.state = {
            toggle: false
        };
    }
    render() {
        const store = this.props.store;
        const amenitiesList = this.createList(store).map((item, index) => {
            return React.createElement("div", { className: "amenities-item", key: index },
                React.createElement("i", { className: "fa fa-check" }),
                React.createElement("span", null, item));
        });
        const amenities = this.state.toggle ? React.createElement("div", { className: "store-amenities" },
            React.createElement("div", { className: "amenities-header" }, "AMENITIES"),
            React.createElement("div", { className: "amenities-list" }, amenitiesList)) : null;
        return (React.createElement("div", { className: "store-card", id: this.props.storeIndex.toString() },
            React.createElement("div", { className: "marker-content" },
                React.createElement(Marker, { markerText: this.props.storeIndex, selected: this.props.selected, updateSelected: this.props.updateSelected, MarkerClick: this.props.MarkerClick, lat: store.Latitude, lng: store.Longitude })),
            React.createElement("div", { className: "store-content" },
                React.createElement("div", { className: "store-header" },
                    React.createElement("a", { href: `/Licensee/Index/${store.Number}`, className: this.props.selected ? "selected" : "" }, store.Name),
                    React.createElement(StoreStar, { id: store.Id }),
                    this.createList(store).length > 0 ? React.createElement("i", { className: this.state.toggle ? "fa fa-chevron-up" : "fa fa-chevron-down", onClick: this.toggleAmenities }) : null),
                React.createElement("div", { className: "store-body" },
                    React.createElement("div", null,
                        React.createElement("span", null, store.StreetAddress),
                        React.createElement("br", null),
                        React.createElement("span", null, `${store.City.trim()},${store.Province.trim()} ${store.PostalCode.trim()}`)),
                    React.createElement("div", null,
                        React.createElement("span", null, store.Phone))),
                React.createElement("div", { className: "store-interact" },
                    React.createElement("div", null,
                        React.createElement("a", { href: `https://www.google.com/maps/dir//'${store.Latitude},${store.Longitude}'` },
                            React.createElement("button", { className: "btn-primary btn-primary__ghost" }, "GET DIRECTIONS"))),
                    React.createElement("div", null, store.Products ?
                        React.createElement("span", { className: "matching-item-link", onClick: this.toggleServices },
                            store.Products.length,
                            " MATCHING ITEM",
                            store.Products.length > 1 ? "S" : "",
                            " ",
                            React.createElement("i", { className: "fa fa-angle-right" })) :
                        null)),
                amenities)));
    }
}
;
//# sourceMappingURL=store-card.js.map